//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class DomEvents
{
	public static destinationUpdated: string = `destinationUpdated`;
	public static destinationDetailBasicInformationLoaded: string = `destinationDetailBasicInformationLoaded`;
	public static destinationDetailPlacesTabShown: string = `destinationDetailPlacesTabShown`;
	public static destinationDetailMapTabShown: string = `destinationDetailMapTabShown`;
	public static destinationDetailMapNewPoiCreated: string = `destinationDetailMapNewPoiCreated`;
	public static poiDetailBasicInformationLoaded: string = `poiDetailBasicInformationLoaded`;
	public static poiDetailAiGeneratedContentModified: string = `poiDetailAiGeneratedContentModified`;
	public static tourDetailBasicInformationLoaded: string = `poiDetailBasicInformationLoaded`;
	public static tourDetailPoiAddedToMapToAddToTheTour: string = `tourDetailPoiAddedToMapToAddToTheTour`;
	public static tourDetailIndoorTourLocationEdited: string = `tourDetailIndoorTourLocationEdited`;
	public static tourRouteGenerated: string = `tourRouteGenerated`;
}
